import { fetchApi } from '@/config/axiosSetting.ts';
import { DocumentationListQueryResponseType } from '@/modules/FileDetail/queries/documentation/list/documentationListQuery.type.ts';

export const documentationListQueryFunction = (
  id: string,
): Promise<DocumentationListQueryResponseType[]> =>
  fetchApi.get(`documents/${id}/documents_list/`);
